import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { getEnv } from '../env/environment.js';
import { getContentfulContent } from '../services/contentfulService.js';
import { initializeI18n } from '../services/i18nService.js';
import EnvProvider from './EnvProvider.js';
import FooterComponent from './FooterComponent/FooterComponent.js';
import ErrorFallback from './SentryErrorBoundary/ErrorFallback.js';
import SentryErrorBoundary from './SentryErrorBoundary/SentryErrorBoundary.js';
import SentryProvider from './SentryProvider.js';

const ShopFooter = ({ stage, locale, domain, footerModel, className, pageWidth = 'narrow' }) => {
    const [i18nInstance] = useState(initializeI18n(domain, locale));
    return (jsx(EnvProvider, { stage: stage, children: jsx(SentryProvider, { children: jsx(SentryErrorBoundary, { fallbackRender: ErrorFallback, children: jsx(I18nextProvider, { i18n: i18nInstance, children: jsx(FooterComponent, { footerModel: footerModel, className: className, pageWidth: pageWidth }) }) }) }) }));
};
const getShopFooterProps = async ({ stage, app, locale, domain, previewMode, }) => {
    const env = getEnv(stage);
    const mappedLocale = locale === 'en' ? 'en-GB' : locale === 'nb-NO' ? 'no-NO' : locale;
    const contenfulResponse = await getContentfulContent({
        url: `${env.footerURL}/${domain}/${mappedLocale}/${app}`,
        previewMode,
    });
    return {
        stage,
        locale,
        domain,
        footerModel: contenfulResponse,
    };
};

export { ShopFooter as default, getShopFooterProps };
//# sourceMappingURL=ShopFooter.js.map
